import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useUserAuthorisation from './useUserAuthorisation';
import useCampaignNavigate from './useCampaignNavigate';
import useIterationNavigate from './useIterationNavigate';
import useUser from './useUser';

interface UseProtectRouteOptions {
    validateAuthorisation?: (auth: ReturnType<typeof useUserAuthorisation>) => boolean;
    iterationRedirect?: string;
    campaignRedirect?: string;
    fallbackRedirect?: string;
  }

const useProtectRoute = (options: UseProtectRouteOptions = {}) => {
  const {
    validateAuthorisation = (authorisation) => authorisation.canUpdateCampaign(),
    iterationRedirect = 'summary',
    campaignRedirect = 'summary',
    fallbackRedirect = '/',
  } = options;

  const authorisation = useUserAuthorisation();
  const hasRequiredAuthorisation = validateAuthorisation(authorisation);
  const navigate = useNavigate();
  const { navigateToIteration } = useIterationNavigate();
  const { navigateToCampaign } = useCampaignNavigate();
  const { getCampaignPathFor } = useCampaignNavigate();
  const { campaignId, iterationId } = useParams();
  const { teamIds } = useUser();

  useEffect(() => {
    if (teamIds != null && teamIds.length > 0 && !hasRequiredAuthorisation) {
      if (iterationId) {
        navigateToIteration(iterationRedirect);
        return;
      }
      if (campaignId) {
        navigateToCampaign(campaignRedirect);
        return;
      }
      navigate(fallbackRedirect);
    }
  }, [teamIds, authorisation, campaignId, iterationId, getCampaignPathFor, navigate, navigateToIteration, navigateToCampaign, validateAuthorisation, iterationRedirect, campaignRedirect, fallbackRedirect, hasRequiredAuthorisation]);
};

export default useProtectRoute;
